import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, LineIcon, LineShareButton, TwitterShareButton } from 'react-share';
import { APP_URL } from 'src/constants';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { BsTwitterX } from 'react-icons/bs';
import styled from 'styled-components';

const WidgetSocialShare = ({ articleLink, eventDataLayer }) => {
  const shareLink = `${APP_URL}${articleLink}`;
  return (
    <>
      <WidgetWrapper className='article-share'>
        <ul className='social'>
          <li>
            <FacebookShareButton
              url={shareLink}
              //! DATALAYER
              target={'_blank'}
              rel={'nofollow'}
              onClick={() =>
                sendDataLayerGlobal({
                  ...eventDataLayer,
                  data: {
                    ...eventDataLayer.data,
                    title: 'facebook',
                    link: shareLink,
                    index: 1
                  }
                })
              }
            >
              <FacebookIcon size={30} round={true} />
            </FacebookShareButton>
          </li>
          <li>
            <TwitterShareButton
              url={shareLink}
              target={'_blank'}
              rel={'nofollow'}
              //! DATALAYER
              onClick={() =>
                sendDataLayerGlobal({
                  ...eventDataLayer,
                  data: {
                    ...eventDataLayer.data,
                    title: 'twitter',
                    link: shareLink,
                    index: 2
                  }
                })
              }
            >
              <div className='x-wrapper'>
                <BsTwitterX />
              </div>
            </TwitterShareButton>
          </li>
          <li>
            <LineShareButton
              target={'_blank'}
              rel={'nofollow'}
              url={shareLink}
              //! DATALAYER
              onClick={() =>
                sendDataLayerGlobal({
                  ...eventDataLayer,
                  data: {
                    ...eventDataLayer.data,
                    title: 'line',
                    link: shareLink,
                    index: 3
                  }
                })
              }
            >
              <LineIcon size={30} round={true} />
            </LineShareButton>
          </li>
          <li>
            <EmailShareButton
              target={'_blank'}
              rel={'nofollow'}
              url={shareLink}
              //! DATALAYER
              onClick={() =>
                sendDataLayerGlobal({
                  ...eventDataLayer,
                  data: {
                    ...eventDataLayer.data,
                    title: 'email',
                    link: shareLink,
                    index: 4
                  }
                })
              }
            >
              <EmailIcon size={30} round={true} />
            </EmailShareButton>
          </li>
        </ul>
      </WidgetWrapper>
    </>
  );
};

const WidgetWrapper = styled.div`
  .social {
    align-items: flex-start !important;
  }
  .x-wrapper {
    width: 29px;
    height: 29px;
    background-color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    svg {
      color: #fff;
      font-size: 14px;
    }
  }
`;
export default WidgetSocialShare;
